import dispatchEvent from "@cirrus/legacy/app-components/utils/dispatchEvent.es6"
import classnames from "classnames"
import { get } from "lodash"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "../../common-styles/styles.less"
import { verticalAlignValues } from "../../constants/index.es6"

import localStyles from "./baseHeaderRow.less"
import Html from "./html.jsx"

export default class extends C {
  static displayName = "TableHeaderRow"

  static propTypes = {
    className: PropTypes.string,
    fixed: PropTypes.bool,
    setHeaderColumnsWidth: PropTypes.func,
    setHeaderScrollPosition: PropTypes.func,
    displayFixed: PropTypes.bool,
    columnsWidth: PropTypes.array,
    fixedHeaderNode: PropTypes.object,
    position: PropTypes.object,
    verticalAlign: PropTypes.oneOf(verticalAlignValues),
    ignoreSizeCalculation: PropTypes.bool,
  }

  static defaultProps = {
    fixed: false,
  }

  constructor(props) {
    super(props)

    this.handleResize = this.handleResize.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.navbarResize = this.navbarResize.bind(this)
  }

  componentDidUpdate() {
    this.handleResize()
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize)
    window.addEventListener("scroll:x", this.handleScroll)
    window.addEventListener("navbar:resize", this.navbarResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
    window.removeEventListener("scroll:x", this.handleScroll)
    window.removeEventListener("navbar:resize", this.navbarResize)
  }

  handleScroll(e) {
    if (get(this, "_row._element") == null) {
      return
    }

    this.props.fixed
      ? this.scrollX(this.props.position, this.props.fixedHeaderNode, e.detail)
      : !this.props.ignoreSizeCalculation &&
        this.props.setHeaderScrollPosition(get(this, "_row._element"))
  }

  handleResize() {
    if (get(this, "_row._element") == null) {
      return
    }

    this.props.fixed
      ? this.resize(this.props.columnsWidth, get(this, "_row._element"))
      : !this.props.ignoreSizeCalculation &&
        this.props.setHeaderColumnsWidth(get(this, "_row._element"))
  }

  resize(width, header) {
    const minWidth = Array.prototype.reduce.call(width, (a, b) => a + b, 0)

    if (minWidth > 0) {
      header.style.minWidth = `${minWidth}px`
    }

    Array.prototype.forEach.call(header.childNodes, (element, index) => {
      const w = width[index]

      if (w > 0) {
        element.style.minWidth = `${w}px`
      }
    })
    Array.prototype.forEach.call(header.childNodes, (element, index) => {
      const w = width[index]

      if (w > 0) {
        element.style.maxWidth = `${w}px`
      }
    })
  }

  scrollX(regularHeader, header, detail) {
    if (
      !header ||
      !regularHeader ||
      regularHeader !== $(detail).find(".on-check-ignore-row-select")[0]
    )
      return
    header.style.left = regularHeader.getBoundingClientRect().left + "px"
    const scrollLeft = detail.scrollLeft + "px"
    const scrollRight = detail.offsetWidth + detail.scrollLeft + "px"

    header.style.clip = "rect(auto " + scrollRight + " 800px " + scrollLeft + ")"
  }

  navbarResize() {
    const interval = setInterval(() => dispatchEvent("resize"), 20)

    setTimeout(() => {
      clearInterval(interval)
    }, 510)
  }

  render() {
    const { children, className, displayFixed, verticalAlign } = this.props

    const rowClass = classnames(styles.hr, className, styles[verticalAlign], {
      [localStyles.hidden]: !displayFixed,
    })

    return (
      <Html
        type={this.props.htmlType}
        ref={(row) => (this._row = row)}
        className={rowClass}
        role="row">
        {children}
      </Html>
    )
  }
}
